import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f303e3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "linked-question"
}
const _hoisted_2 = { class: "linked-question-title" }
const _hoisted_3 = { class: "linked-question-wording" }
const _hoisted_4 = { class: "ml-1" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "ml-4" }
const _hoisted_7 = { class: "radio" }
const _hoisted_8 = ["name", "value"]
const _hoisted_9 = { class: "radio-elmt mt-2 ml-2 mb-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
], -1))
const _hoisted_11 = { class: "radio-text" }

export function render(_ctx, _cache) {
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["radiobutton-vertical", _ctx.validForm() ? 'answered' : ''])
  }, [
    (_ctx.question.linkedMainQuestion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.question.linkedQuestionTitle), 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.question.linkedMainQuestion?.wording), 1),
          _createElementVNode("div", null, "Answer: " + _toDisplayString(_ctx.getLinedQuestionResponse(_ctx.question.linkedMainQuestion?.responses)), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h4", _hoisted_4, [
      _createTextVNode(_toDisplayString(_ctx.newWording) + " ", 1),
      _createVNode(_component_Popover, { popover: _ctx.obj }, null, 8, ["popover"])
    ]),
    (_ctx.question.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.question.description), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.responses, (option) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: _ctx.uniqueIdName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectedOption) = $event)),
            value: option.value
          }, null, 8, _hoisted_8), [
            [_vModelRadio, _ctx.selectedOption]
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(option.wording), 1)
          ])
        ])
      ]))
    }), 256))
  ], 2))
}